<template>
	<div>
		<div class="header px-0">
			<div>
				Invite
				{{ partnerType }}
			</div>
		</div>
		<v-btn
			fab
			flat
			class="top-right-align pa-0 ma-0 pt-1"
			@click="closeModal"
		>
			<v-icon>close</v-icon>
		</v-btn>
		<div class="pa-4">
			<v-text-field
				type="text"
				label="Phone Number"
				v-model="inviteNumber"
				onpaste="return false;"
				oncopy="return false"
				prepend-icon="phone"
				placeholder="Enter Phone Number"
				class="text-field-wrapper pt-4"
				:rules="[requiredRule, onlyDigitRule]"
				maxlength="10"
			></v-text-field>
			<div>
				<v-btn
					class="ma-0 mt-3 pa-4 white--text full-width btn"
					:color="themeInputColor"
					:loading="sendInviteLoading"
					@click="sendInvite"
					:disabled="
						/\D/g.test(inviteNumber) || inviteNumber.length !== 10
					"
					>Send Invite</v-btn
				>
			</div>
		</div>
	</div>
</template>
<script>
import * as utils from "@/utils";
import { mapState } from "vuex";
import { SEND_INVITE } from "@/store/action-types";
export default {
	name: "InviteRetailer",
	props: ["themeInputColor", "partnerType", "model", "partnerPhoneNo"],
	data() {
		return {
			inviteNumber: null,
			sendInviteLoading: false,
			requiredRule: v => utils._requiredRule(v),
			onlyDigitRule: v => utils._onlyDigitsRule(v)
		};
	},
	computed: {
		...mapState({
			userId: state => state.auth.USERID
		})
	},
	methods: {
		sendInvite() {
			if (!this.sendInviteLoading) {
				this.sendInviteLoading = true;
				let payload = {
					referrerId: this.userId,
					phoneNo: parseInt(this.inviteNumber, 10),
					countryAreaCode: 91,
					type: this.partnerType
				};
				if (this.partnerType === "retailerInvite") {
					payload = {
						...payload,
						dstrPhone: this.partnerPhoneNo.toString()
					};
				}
				this.$store
					.dispatch(SEND_INVITE.dispatch, payload)
					.then(() => {
						this.sendInviteLoading = false;
						this.closeModal();
					})
					.catch(err => {
						console.error(err);
						this.sendInviteLoading = false;
					});
			}
		},
		closeModal() {
			this.$emit("CLOSE_MODAL", this.model);
		}
	}
};
</script>
<style scoped>
.header {
	border-radius: 16px 16px 0 0;
	background-color: #edf0f7;
	color: #233b5d;
	font-weight: 500;
	font-size: 20px;
	line-height: 21px;
	padding: 1em;
	text-align: center;
	letter-spacing: 0.004em;
	text-transform: capitalize;
}
</style>
